<template>
  <div>
    <b-dropdown-item
      :to="{
        name: 'map',
        params: {
          type: 'charging'
        }
      }"
    >Charging Stations</b-dropdown-item>
    <!-- <b-dropdown-item
      :to="{
        name: 'map',
        params: {
          type: 'heatmap'
        }
      }"
    >Heatmap</b-dropdown-item>
    <b-dropdown-item
      :to="{
        name: 'map',
        params: {
          type: 'futureheatmap'
        }
      }"
    >Heatmap Future</b-dropdown-item> -->
  </div>
</template>

<script>
export default {
  name: 'MapTypeDropdown'
}

</script>

<style scoped>

</style>
